<template>
  <div class="date-component" :class="{ 'date-warning': isError }">
    <date-picker
      placeholder="เลือกวันที่"
      v-model="date"
      :clearable="false"
      :disabled="disabledDate"
      lang="en"
      @change="onSelectDate(date)"
      @clear="onClear()"
      :type="dateTime ? 'datetime' : 'date'"
      :format="dateTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'"
      confirm
    />
    <span v-if="isError" class="validate-invalid" v-html="invalid"></span>
  </div>
</template>

<script>
// import ilbs
import DatePicker from 'vue2-datepicker'
export default {
  name: 'DateBaseComponent',
  components: {
    DatePicker,
  },
  props: {
    defaultValue: {
      type: String,
      default: '',
    },
    defaultDate: {
      type: Boolean,
      default: false,
    },
    disabledDate: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: String,
      default: '',
    },
    dateTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: '',
    }
  },
  watch: {
    defaultValue: function(value) {
      this.date = value
    },
    deep: true,
  },
  created() {
    if (this.defaultDate) {
      this.date = new Date()
      this.onSelectDate(this.date)
    }
  },
  methods: {
    async onSelectDate(date) {
      if (date) {
        date = new Date(date).toLocaleString('en-US', {
          timeZone: 'Asia/Bangkok',
        })
        await this.$emit('selected', date)
      }
    },
    onClear() {
      this.$emit('selected', '')
    },
  },
}
</script>
